export function capitalize(w: string) {
    if (!w || !w.length) {
        return w;
    }

    return w[0].toUpperCase() + w.slice(1);
}
